// react-credit-cards-2 returns issuer ids via its callback.

import { CARD_RULES } from '../constants'

// Keep aliasing explicit so we can adjust easily if the lib changes.
const BRAND_ALIASES: Record<string, string> = {
  'american-express': 'amex',
  americanexpress: 'amex',
  'diners-club': 'diners',
  dinersclub: 'diners',
  amex: 'amex',
  visa: 'visa',
  mastercard: 'mastercard',
  hipercard: 'hipercard',
  unknown: 'default'
}

export function normalizeCardBrand(brand?: string | null): string {
  const b = (brand ?? '').toLowerCase().trim()
  return BRAND_ALIASES[b] ?? b
}

export function getCardRuleByBrand(brand?: string | null): CardRule {
  const normalized = normalizeCardBrand(brand)
  return CARD_RULES?.[normalized] ?? CARD_RULES.default
}

/**
 * react-credit-cards-2 sometimes reports maxLength=16 while the user hasn't typed past 16,
 * even for 19-digit issuers. Use this to keep the input mask consistent with what the lib expects.
 */
export function getCardNumberMask(
  brand?: string | null,
  maxLength?: number
): string {
  const rule = getCardRuleByBrand(brand)
  const effectiveMax = maxLength ?? rule.numberLength

  // if we are dealing with a 19-digit issuer but the lib is still on 16, use 16 mask temporarily
  if (rule.numberLength > 16 && effectiveMax <= 16) {
    return '#### #### #### ####'
  }

  return rule.mask
}
